import { render } from "./PackageSelect.vue?vue&type=template&id=7745e37e&scoped=true"
import script from "./PackageSelect.vue?vue&type=script&lang=js"
export * from "./PackageSelect.vue?vue&type=script&lang=js"

import "./PackageSelect.vue?vue&type=style&index=0&id=7745e37e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7745e37e"]])

export default __exports__